export default __webpack_public_path__ + "static/media/empire_state_building_by_night.1e651e4d.jpg";